/**
 * Analytics payload sanitization (Milestone 15).
 */
const HTML_TAG_RE = /<[^>]*>/g;

const SENSITIVE_KEYS = new Set([
  "phone",
  "whatsapp",
  "buyerWhatsapp",
  "buyerEmail",
  "buyerName",
  "email",
  "contact",
  "firstName",
  "lastName",
  "message",
  "messageToDealer",
  "messageText",
  "password",
  "token",
  "authorization",
  "stack",
  "stackTrace",
]);

const LONG_TEXT_KEYS = new Set(["description", "seoDescription", "introCopy", "notes", "comment"]);

const MAX_STRING_LENGTH = 240;
const MAX_KEYWORD_LENGTH = 80;

function looksLikePhone(value) {
  if (typeof value !== "string") return false;
  const digits = value.replace(/\D/g, "");
  return digits.length >= 10;
}

function trimString(value, maxLength = MAX_STRING_LENGTH) {
  const text = String(value).replace(HTML_TAG_RE, " ").replace(/\s+/g, " ").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
}

function sanitizeValue(key, value) {
  if (value == null) return undefined;

  if (SENSITIVE_KEYS.has(key)) return undefined;
  if (typeof value === "string" && looksLikePhone(value)) return undefined;

  if (typeof value === "string") {
    if (key === "keyword" || key === "searchQuery" || key === "query") {
      return trimString(value, MAX_KEYWORD_LENGTH) || undefined;
    }
    if (LONG_TEXT_KEYS.has(key)) return undefined;
    return trimString(value);
  }

  if (typeof value === "boolean" || typeof value === "number") return value;

  if (value instanceof Date) return value.toISOString();

  if (Array.isArray(value)) {
    const cleaned = value
      .map((entry) => (typeof entry === "object" && entry != null ? sanitizeAnalyticsPayload(entry) : entry))
      .filter((entry) => entry != null && entry !== "");
    return cleaned.length ? cleaned : undefined;
  }

  if (typeof value === "object") {
    return sanitizeAnalyticsPayload(value);
  }

  return value;
}

export function sanitizeAnalyticsPayload(payload = {}) {
  if (!payload || typeof payload !== "object") return {};

  const clean = {};
  for (const [key, value] of Object.entries(payload)) {
    const sanitized = sanitizeValue(key, value);
    if (sanitized !== undefined && sanitized !== null && sanitized !== "") {
      clean[key] = sanitized;
    }
  }
  return clean;
}

export { SENSITIVE_KEYS };
